import React, {Component} from 'react'
import {CardHeader, CardBody, Button} from 'reactstrap'
import ProjectForm from './ProjectForm'
import ConfirmModal from '../Alerts/ConfirmModal'
import PropTypes from 'prop-types'
import {UnmountClosed} from 'react-collapse'
import queryString from 'query-string'
import {graphql, compose} from 'react-apollo'
import {ProjectsListQuery, destroyProjectsMutation} from './mutations'
import BlockWithLoader from '../Support/BlockWithLoader'
import {getUserPermissions} from '../../utils/userPermissions'
import ElementsList from './helpers/ElementsList'
import {RiseLoader} from 'react-spinners'

class ProjectsList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      projectsList: [],
      formIsOpened: false,
      dataToEdit: {},
      page: 1,
      totalPages: 1,
      loadingMore: false,
      projectIdRemove: null,
      nameFilter: queryString.parse(this.props.location.search).name || ''
    }
    this.closeConfirmModal = this.closeConfirmModal.bind(this)
    this.runRemoveProject = this.runRemoveProject.bind(this)
    this.scrollRef = React.createRef()
    this.handleScroll = this.handleScroll.bind(this)
  }

  static propTypes = {
    data: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    destroyProjectsMutation: PropTypes.func.isRequired,
  }

  componentDidMount() {
    if (this.scrollRef.current) {
      this.scrollRef.current.addEventListener('scroll', this.handleScroll)
    }
  }

  componentDidUpdate() {
    if (this.scrollRef.current && !this.scrollRef.current._scrollBound) {
      this.scrollRef.current.addEventListener('scroll', this.handleScroll)
      this.scrollRef.current._scrollBound = true
    }
  }

  componentWillUnmount() {
    if (this.scrollRef.current) {
      this.scrollRef.current.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll() {
    const el = this.scrollRef.current
    console.log('scroll', {scrollTop: el && el.scrollTop, clientHeight: el && el.clientHeight, scrollHeight: el && el.scrollHeight, loadingMore: this.state.loadingMore, loading: this.props.data.loading, page: this.state.page, totalPages: this.state.totalPages})
    if (!el || this.state.loadingMore || this.props.data.loading) return
    if (this.state.page >= this.state.totalPages) return
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
      this.loadNextPage()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data.loading === false && nextProps.data.loading === false && nextProps.history.action === 'PUSH') {
      this.setState({projectsList: [], page: 1}, () => this.props.data.refetch({page: 1}))
      return
    }

    if (nextProps.data.projects && !nextProps.data.loading) {
      const newProjects = nextProps.data.projects.list
      const totalPages = nextProps.data.projects.metadata.total_pages
      this.setState(prev => ({
        projectsList: prev.loadingMore
          ? [...prev.projectsList, ...newProjects]
          : newProjects,
        totalPages,
        loadingMore: false
      }))
    }
  }

  loadNextPage() {
    const nextPage = this.state.page + 1
    this.setState({loadingMore: true, page: nextPage}, () => {
      this.props.data.fetchMore({
        variables: {page: nextPage, name: this.state.nameFilter || undefined},
        updateQuery: (prev, {fetchMoreResult}) => fetchMoreResult || prev
      })
    })
  }

  handleNameFilter = (name) => {
    const search = name ? `?name=${encodeURIComponent(name)}` : ''
    this.props.history.replace(`/projects${search}`)
    this.setState({nameFilter: name, projectsList: [], page: 1}, () => {
      this.props.data.refetch({page: 1, pageSize: 10, name: name || undefined})
    })
  }

  runRemoveProject() {
    this.removeProject(this.state.projectIdRemove)
  }

  removeProject(id) {
    this.props.destroyProjectsMutation({
      variables: {id: id}
    }).then(() => {
      let newProjectsList = this.state.projectsList.filter(function (item) {
        return (item.id !== id)
      })
      this.setState({projectsList: newProjectsList, projectIdRemove: null})
    })
  }

  closeConfirmModal() {
    this.setState({projectIdRemove: null})
  }

  render() {
    if (this.props.data.error) {
      return (<div>An unexpected error occurred</div>)
    }

    return (
      <BlockWithLoader loading={this.props.data.loading} renderChildren={true}>
        <UnmountClosed isOpened={this.state.formIsOpened}>
          <CardHeader>{this.state.dataToEdit.id ? 'Edit Project' : 'Add new project'}</CardHeader>
          <CardBody>
            <ProjectForm
              editData={this.state.dataToEdit}
              formToggleFunction={() => this.setState({formIsOpened: false, dataToEdit: {}})}
              companiesData={this.props.data.companies && this.props.data.companies.list}
            />
          </CardBody>
        </UnmountClosed>
        <ConfirmModal
          isOpened={!!this.state.projectIdRemove}
          onCancel={this.closeConfirmModal}
          onConfirm={this.runRemoveProject}
          headerText='Remove Project'
          bodyText='Are you sure you want to delete this project?'
          confirmBtnText='Remove'
        />
        <CardHeader>
          <b>Projects</b>
        </CardHeader>

        <CardBody style={{position: 'relative', opacity: this.state.loadingMore ? 0.5 : 1}}>
            {!this.state.formIsOpened && getUserPermissions('wl_welds.projects.create') &&
            <Button
              id="add-new-proj-btn"
              color="primary"
              className="float-right btn-add-project"
              onClick={() => this.setState({formIsOpened: true})}
            >
              <i className="fa fa-plus"/> Add new project
            </Button>}
            <ElementsList
              history={this.props.history}
              companiesData={this.props.data.companies ? this.props.data.companies.list : []}
              onEdit={this.state.formIsOpened ? null : (project) => this.setState({dataToEdit: project, formIsOpened: true})}
              onDestroy={(project_id) => this.setState({projectIdRemove: project_id})}
              elements={this.state.projectsList}
              scrollRef={this.scrollRef}
              onNameFilter={this.handleNameFilter}
              loading={this.props.data.loading || this.state.loadingMore}
              initialNameFilter={this.state.nameFilter}
            />
            {this.state.loadingMore && <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}><RiseLoader color="#20a8d8" loading={true}/></div>}
          </CardBody>
      </BlockWithLoader>
    )
  }
}

const ProjectsListWithMutations = compose(
  graphql(ProjectsListQuery,
    {
      options: (props) => ({
        fetchPolicy: 'network-only',
        variables: {page: 1, pageSize: 10, name: queryString.parse(props.location.search).name || undefined}
      })
    }
  ),
  graphql(destroyProjectsMutation, {name: 'destroyProjectsMutation'}))(ProjectsList)

export default ProjectsListWithMutations



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectsList.js